import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'file'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            visibleCrop: false,
            showLoading: true,
            selectedOption: '',
            hasError: '',
            selectedFile: null
        };
    },

    watch: {
        show: function(val, oldVal) {
            let _self = this;
            if(val){
                this.showLoading = true;
                this.selectedFile = this.file
                this.visibleCrop = true
                setTimeout(function() {
                    _self.showLoading = false
                    _self.cropImage();
                    // Ovde možete staviti kod koji želite da se izvrši nakon određenog vremena
                }, 500); //

            }else {
                this.visibleCrop = false
                this.showLoading = true;
            }
        },
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeCropImage')
            this.selectedFile = null;
        },
        keymonitor: keymonitor,
        reset:reset,
        load: load,
        cropImage: cropImage,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        }
    },
    mounted() {
        let recaptchaScript2 = document.createElement('link')
        recaptchaScript2.setAttribute('rel', 'stylesheet')
        recaptchaScript2.setAttribute('href', 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.12/cropper.min.css')
        document.head.appendChild(recaptchaScript2)

        let recaptchaScript3 = document.createElement('script')
        recaptchaScript3.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.12/cropper.min.js')
        document.head.appendChild(recaptchaScript3)
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {

}

function reset(){

}

function cropImage(){
    var cropper;
    var image = document.getElementById('image1');
    const cropButton = document.getElementById('cropButton1');
    if(image == null) return;
    image.src = this.selectedFile;
    image.style.display = 'block';

    if (cropper) {
        console.log("here")
        console.log(image)
        cropper.replace(this.selectedFile);
    } else {
        console.log("here2")
        console.log(image)
        if (cropper) {
            console.log('destroy copper')
            // Uništite prethodni cropper
            cropper.destroy();
            cropper = null;
        }

        cropper = new Cropper(image, {
            // aspectRatio: 3/1, // Odnos stranica kropovanja (ovde je 1:1)
            // viewMode: 1, // Prikazuje samo kropovani deo slike
            // movable: true,
            // responsive: true,
            movable: true, // Omogućava pomeranje kropovane slike
            zoomable: false, // Omogućava zumiranje slike
            rotatable: true, // Omogućava rotaciju slike
            responsive: true, // Omogućava automatsko prilagođavanje veličine kropera
            viewMode: 3, //
            crop: function(event) {
                // Funkcija se poziva nakon svake promene kropovanja
            },
        });
    }


    cropButton.addEventListener('click', () => {
        // Kada korisnik klikne na dugme "Kropuj"
        const canvas = cropper.getCroppedCanvas();
        canvas.toBlob((blob) => {
            const croppedFile = new File([blob], 'cropped_image.png', { type: 'image/png' });
            this.$topnavbar.$emit('croppedImage', croppedFile)
            this.selectedFile = null;

            // image.style.display = 'none';
            // cropButton.style.display = 'none';
            // _self.recognizeFromCrop(croppedFile)
        });


    });
}



// WEBPACK FOOTER //
// ./src/modals/CropImageModal.js